import { Module } from 'vuex';
import { Actions } from './actions';
import { Mutations } from './mutations';
import { RootState } from './root.store';

export interface RulesState {
  largeScreen: boolean;
}

export const RulesModule: Module<RulesState, RootState> = {
  state: {
    largeScreen: false,
  },
  mutations: {
    [Mutations.rules.setLargeScreen](state, isLargeScreen: boolean) {
      state.largeScreen = isLargeScreen;
    },
  },
  actions: {
    [Actions.rules.setLargeScreen]({ commit }, isLargeScreen: boolean) {
      commit(Mutations.rules.setLargeScreen, isLargeScreen);
    },
  },
};
